import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ViewTemplate = ({ template }) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    setKey((prevKey) => prevKey + 1);
  }, [template]);

  const sanitizedTemplate = DOMPurify.sanitize(template || '');

  return (
    <div className='mt-2'>
      <ReactQuill
        key={key}
        value={sanitizedTemplate}
        readOnly={true}
        theme="snow"
        modules={{ toolbar: false }}
      />
    </div>
  );
};

export default ViewTemplate;
